import { render, staticRenderFns } from "./Dialog_PastReturnDetail.vue?vue&type=template&id=52666c04&scoped=true&"
import script from "./Dialog_PastReturnDetail.vue?vue&type=script&lang=js&"
export * from "./Dialog_PastReturnDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52666c04",
  null
  
)

export default component.exports